module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: " weex-ct weex-div",
    attrs: {
      "weex-type": "div"
    }
  }, [_c('div', {
    staticClass: " weex-ct weex-div",
    attrs: {
      "weex-type": "div",
      "data-evt-touchend": ""
    },
    on: {
      "touchend": function($event) {
        $event.stopPropagation();
        return _vm.handleTouchEnd($event)
      }
    }
  }, [(_vm.show) ? _c('dof-overlay', _vm._b({
    ref: "overlay",
    attrs: {
      "show": _vm.haveOverlay && _vm.isOverShow,
      "data-evt-dofOverlayBodyClicked": ""
    },
    on: {
      "dofOverlayBodyClicked": _vm.dofOverlayBodyClicking
    }
  }, 'dof-overlay', _vm.overlayCfg, false)) : _vm._e()], 1), _vm._v(" "), (_vm.show) ? _c('div', {
    ref: "dof-popup",
    staticClass: " weex-ct weex-div",
    class: ['dof-popup', _vm.pos],
    style: (_vm._px2rem(_vm.padStyle, 75)),
    attrs: {
      "height": _vm._height,
      "hack": _vm.isNeedShow,
      "weex-type": "div",
      "data-evt-click": ""
    },
    on: {
      "click": _vm.$stopOuterA,
      "weex$tap": function($event) {
        $event.stopPropagation();
        return (function () {})($event)
      }
    }
  }, [_vm._t("default", null, {}), _vm._v(" "), (_vm.button && _vm.button.length > 0) ? _c('div', {
    staticClass: " weex-ct weex-div",
    staticStyle: {
      "width": "10rem",
      "height": "0.26667rem",
      "background-color": "#F3F3F3"
    },
    attrs: {
      "weex-type": "div"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.button && _vm.button.length > 0) ? _c('div', {
    staticClass: "midea-actionsheet-bottom weex-ct weex-div",
    attrs: {
      "weex-type": "div"
    }
  }, [_c('p', {
    staticClass: "midea-actionsheet-btn leftBtn weex-el weex-text",
    attrs: {
      "weex-type": "text",
      "data-evt-click": ""
    },
    on: {
      "click": _vm.$stopOuterA,
      "weex$tap": function($event) {
        $event.stopPropagation();
        return _vm.actionsheetBtnClick(0, _vm.button[0])
      }
    }
  }, [_vm._v(_vm._s(_vm.button[0]))]), _vm._v(" "), (_vm.button.length > 1) ? _c('p', {
    staticClass: "midea-actionsheet-btn rightBtn weex-el weex-text",
    attrs: {
      "weex-type": "text",
      "data-evt-click": ""
    },
    on: {
      "click": _vm.$stopOuterA,
      "weex$tap": function($event) {
        $event.stopPropagation();
        return _vm.actionsheetBtnClick(1, _vm.button[1])
      }
    }
  }, [_vm._v(_vm._s(_vm.button[1]))]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: " weex-ct weex-div",
    style: ({
      height: _vm._px2rem(_vm.show && _vm.isipx ? '68px' : '0px', 75)
    }),
    attrs: {
      "weex-type": "div"
    }
  })], 2) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-89c4d90c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-89c4d90c","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/dof-select-picker/index.vue
// module id = 642
// module chunks = 0 1